import { TaskCategory } from 'aos-services/src/services/tasks/types/TaskCategory'
import { Icon } from 'aos-ui-universal'
import React, { FC } from 'react'

import { taskIcon } from '../../utils'

interface TaskIconProps {
    category: TaskCategory
    size?: number
    color?: string
}

export const TaskIcon: FC<TaskIconProps> = ({ category, size = 24, color }) => (
    <Icon size={size} as={taskIcon[category]} color={color} />
)
